<template>
	<span class="wqa-design">
		<span id="site-wrapper">
			<div id="offcanvas-menu" :class="{ 'offcanvas-menu-left': !!isLeftBurgerMenuOpen && isDropdownVisible }">
				<div class="mobile-menu mobile-menu--nav">
					<div class="mobile-menu__body">
						<div class="push-nav">
							<ul class="push-nav__list push-nav__list--top">
								<li class="push-nav__item has-child-menu" style="display:flex;flex-direction: column;">
									<!-- <div> -->
									<!-- <RouterLink to="/products"> -->
										<a class="push-nav__link" style="padding-right:15px;"
										@click="isMobileCategoriesVisible = !isMobileCategoriesVisible">
										<a style="text-decoration: none">
										<!-- <RouterLink to="/products" style="text-decoration: none"> -->
											Products
										</a> 
									</a>
									<!-- </RouterLink> -->
									<div v-if="!!isMobileCategoriesVisible">
										<ul>
											<li v-for="category in categories" :key="category.id" style="font-size:16px;margin-top: 10px;margin-bottom: 10px;">
												<RouterLink :to="'/products/' + category.slug" style="text-decoration: none">
													<strong>{{ category.name }}</strong>
												</RouterLink>
												<a @click="toggleSubcategory(category.id)"><img loading="lazy" src='~@/assets/common/images/icons/arrow-down-brand.png' style="width: 35px;" /></a>

												<ul v-if="activeCategory === category.id" style="font-size:16px">
													<li v-for="(subcategory, index) in category.subcategories" :key="index">
														<RouterLink :to="'/products/' + subcategory.slug" style="text-decoration: none">
															{{ subcategory.name }}
														</RouterLink>
													</li>
												</ul>
											</li>
										</ul>
									</div>
								</li>
								<li class="push-nav__item">
									<router-link to="/our-story" class="push-nav__link">Our Story</router-link>
									<!-- <a class="push-nav__link" style="padding-right:0px;" @click="isMobileStoriesVisible = !isMobileStoriesVisible">Our Story</a> -->
									<!-- <div v-if="!!isMobileStoriesVisible">
										<ul>
											<li style="font-size:16px;margin-top: 10px;margin-bottom: 10px;">
												<RouterLink to="/about-our-story" style="text-decoration: none">
													<strong>Our History</strong>
												</RouterLink>
											</li>
											<li style="font-size:16px;margin-top: 10px;margin-bottom: 10px;">
												<RouterLink to="/why-modiway" style="text-decoration: none">
													<strong>Why Modiway?</strong>
												</RouterLink>
											</li>
											<li style="font-size:16px;margin-top: 10px;margin-bottom: 10px;">
												<RouterLink to="/" style="text-decoration: none">
													<strong>Modicare Foundation-MCF</strong>
												</RouterLink>
											</li>
										</ul>
									</div> -->
								</li>
								<!-- <li class="push-nav__item"><a class="push-nav__link" style="padding-right:0px;" @click="isMobileDiscoverVisible = !isMobileDiscoverVisible">Discover</a> -->
									<!-- <div v-if="!!isMobileDiscoverVisible">
										<ul>
											<li style="font-size:16px;margin-top: 10px;margin-bottom: 10px;">
												<RouterLink to="/about-our-story" style="text-decoration: none">
													<strong>Our History</strong>
												</RouterLink>
											</li>
											<li style="font-size:16px;margin-top: 10px;margin-bottom: 10px;">
												<RouterLink to="/why-modiway" style="text-decoration: none">
													<strong>Why Modiway?</strong>
												</RouterLink>
											</li>
											<li style="font-size:16px;margin-top: 10px;margin-bottom: 10px;">
												<RouterLink to="/" style="text-decoration: none">
													<strong>Modicare Foundation-MCF</strong>
												</RouterLink>
											</li>
										</ul>

									</div> -->
									<!-- <a href="#" class="push-nav__link">Discover</a> -->
									<!-- <ul class="push-nav__list push-nav__list--l1">
										<li class="push-nav__item push-nav__item--header">
											<a href="#" class="mobile-menu__item-link">View Discover Home</a>
										</li>
									</ul> -->
								<!-- </li> -->
								<li class="push-nav__item">
									<routerlink to="/resources" class="push-nav__link d-md-none" target="_self">Resources</routerlink>
								</li>
								<li class="push-nav__item" @click="logout" v-if="!!isLoggedIn">
									<a href="#" class="push-nav__link d-md-none" target="_self">Logout</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<header id="header" class="header" role="navigation">
				<div class="container">
					<div class="row">
						<div class="col-sm-12">
							<div class="header__inner">
								<nav class="mobile__toolbar d-lg-none">
									<ul class="nav">
										<li class="nav__item">
											<a class="nav__link nav__link--icon" @click="toggleLeftDrawer" style="cursor: pointer;">
												<span class="icon--burger" v-if="!isLeftBurgerMenuOpen"></span>
												<span class="icon--cross" v-if="isLeftBurgerMenuOpen "></span>
												<span class="d-none d-lg-block">Menu</span>
											</a>
										</li>
									</ul>
								</nav>
								<div class="header__logo" style="justify-content:start;">
									<router-link :to="logoData.route" class="header__logo-link">
										<img loading="lazy" class="header__logo-image d-none d-lg-block" :src="currentLogo" alt="Modiway" style="width: 100%;height: 100%;max-width:203px !important;">
										<img loading="lazy" class="header__logo-image d-lg-none" :src="currentLogo" alt="Modiway"  style="width: 170px;height:95px !important;">
									</router-link>
								</div>
								<!-- <div class="header__logo" style="justify-content:start;">
									<router-link :to="logoData.route" class="header__logo-link">
										<img loading="lazy" class="header__logo-image d-none d-lg-block" :src="logoData.desktopLogo" alt="Modiway" style="width: 100%;height: 100%;max-width:203px !important;">
										<img loading="lazy" class="header__logo-image d-lg-none" :src="logoData.mobileLogo" alt="Modiway" style="width: 100%;height:100% !important;">
									</router-link>
								</div> -->
								<div class="header__search__wrapper">
									<nav class="header__nav d-none d-lg-flex">
										<ul class="nav">
											<li class="nav__item">
												<!-- ShopHeaderMainLink -->
												<router-link class="nav__link" to="/products" js-mega-link data-mega-name="shop" @mouseenter="toggleDropdown">Products</router-link>
												<!-- End ShopHeaderMainLink -->
												<div class="menu-dropdown menu-dropdown--shop" data-mega-name="shop"  v-if="isDropdownVisible">
													<div class="container">
														<div class="row">
															<div class="col-sm-12">
																<div class="menu-dropdown__body">
																	<!-- <button class="menu-dropdown__close">
																		<i class="icon--cross icon--md"></i>
																	</button> -->
																	<div class="menu-dropdown__intro">
																		<!-- <span
																			class="menu-dropdown__subtitle menu-dropdown__subtitle--store">India</span> -->
																		<!-- HeaderShopDropdownCol1Paragraph -->
																		<h3 class="menu-dropdown__title">Modiway
																			Products</h3>
																		<p>Need ideas on how to use your oils? From
																			product spotlights to recipes and DIYs, our
																			blogs provide many unique and innovative
																			ways to use your safely and effectively.</p>
																		<!-- End HeaderShopDropdownCol1Paragraph -->
																	</div>
																	<div class="menu-dropdown__nav">
																		<div class="drill-nav">
																			<ul class="drill-nav__list">
																				<li class="drill-nav__item has-child-menu" v-for="category of categories" @mouseenter="showSubcategories(category.id)" @mouseleave="hideSubcategories" :key="category.id">

																					<RouterLink :to="'/products/' + category.slug" class="drill-nav__link">{{ category.name }}</RouterLink>
																					<ul class="drill-nav__list">
																						<li class="drill-nav__item" :key="subcategory.id" v-for="subcategory of category.subcategories">
																							<RouterLink :to="'/products/' + subcategory.slug" class="drill-nav__link child">{{ subcategory.name }}</RouterLink>
																						</li>
																					</ul>
																				</li>
																			</ul>
																		</div>
																	</div>
																	<div class="menu-dropdown__promo">
																		<!-- HeaderShopDropdownCol3Banner -->
																		<a href="#">
																			<img loading="lazy" style="width:250px;height:250px;" src="~@/assets/medias/400X400Promotion-Monthly.jpeg" />
																		</a>
																		<!-- End HeaderShopDropdownCol3Banner -->
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div> <!-- /.menu-dropdown -->
											</li>
											
											<li class="nav__item">
												<!-- OurStoryHeaderMainLink - Desktop -->
												<router-link to="/our-story" class="nav__link">Our Story</router-link>
												<!-- End OurStoryHeaderMainLink - Desktop -->
											</li>
											<li class="nav__item">
												<router-link to="/resources" class="nav__link">Resources</router-link>
											</li>
											<li class="nav__item">

												<!-- DiscoverHeaderMainLink -->
												<!-- <a class="nav__link" href="#" js-mega-link data-mega-name="discover" @mouseenter="toggleDropdown">Discover</a> -->
												<!-- End DiscoverHeaderMainLink -->

												<div class="menu-dropdown menu-dropdown--discover" data-mega-name="discover"  v-if="isDropdownVisible">
													<div class="container">
														<div class="row">
															<div class="col-sm-12">
																<div class="menu-dropdown__body">
																	<!-- <button class="menu-dropdown__close">
																		<i class="icon--cross icon--md"></i>
																	</button> -->
																	<div class="menu-dropdown__row">
																		<div class="menu-dropdown__column menu-dropdown__column--wx4">
																			<!-- DiscoverDropdownSection1 -->
																			<h3 class="menu-dropdown__title">Discover
																			</h3>
																			<p>Learn what are and how to use them.</p>
																			<!-- End DiscoverDropdownSection1 -->

																			<div class="simple-menu simple-menu--3col mt-5">
																				<!-- DiscoverDropdownSection2 -->
																				<div class="simple-menu__column">
																					<h3 class="menu-dropdown__subtitle">
																						Product Education</h3>
																					<ul class="simple-menu__list simple-menu__list--wpd">
																						<li class="simple-menu__item">
																							<a href="#" target="_self" class="simple-menu__link">
																							</a>
																						</li>
																						<li class="simple-menu__item">
																							<router-link to="/education-and-training" target="_self" class="simple-menu__link">
																								Education and
																								Training</router-link>
																						</li>
																						<!-- <li class="simple-menu__item">
																							<router-link
																								to="/aromatouch-technique-new"
																								target="_blank"
																								class="simple-menu__link">
																								Modiway
																								AromaTouch<sup>®</sup>
																								Technique</router-link>
																						</li> -->
																					</ul>
																				</div>
																				<div class="simple-menu__column">
																					<h3 class="menu-dropdown__subtitle">
																						Social Media</h3>
																					<ul class="simple-menu__list simple-menu__list--wpd">
																						<li class="simple-menu__item">
																							<a href="#" target="_self" class="simple-menu__link">
																							</a>
																						</li>
																						<li class="simple-menu__item">
																							<a href="https://www.instagram.com/Modiwayindiaofficial/" target="_blank" class="simple-menu__link gaCrossDomain">
																								Instagram</a>
																						</li>
																						<li class="simple-menu__item">
																							<a href="https://www.facebook.com/profile.php?id=61559015863183&mibextid=LQQJ4d" target="_blank" class="simple-menu__link gaCrossDomain">
																								Facebook</a>
																						</li>
																						<li class="simple-menu__item">
																							<a href="https://www.youtube.com/c/Modiwaycorp" target="_blank" class="simple-menu__link gaCrossDomain">
																								YouTube</a>
																						</li>
																						<li class="simple-menu__item">
																							<a href="https://Modiwayindiamarket.teamapp.com/" target="_blank" class="simple-menu__link gaCrossDomain">
																								LinkedIn</a>
																						</li>
																						<li class="simple-menu__item">
																							<a href="https://Modiwayindiamarket.teamapp.com/" target="_blank" class="simple-menu__link gaCrossDomain">
																								Weight Management App</a>
																						</li>
																					</ul>
																				</div>
																				<div class="simple-menu__column">
																					<h3 class="menu-dropdown__subtitle">
																						Modiway Leaders</h3>
																					<ul class="simple-menu__list simple-menu__list--wpd">
																						<li class="simple-menu__item">
																							<a href="#" target="_self" class="simple-menu__link">
																							</a>
																						</li>
																						<li class="simple-menu__item">
																							<a href="../home/en_IN/Modiway-recognition-and-ranks.html" target="_blank" class="simple-menu__link">
																								Meet our Leaders</a>
																						</li>
																						<li class="simple-menu__item">
																							<router-link to="/incentive-trip-2025" target="_blank" class="simple-menu__link">
																								Incentive Trip
																								2025</router-link>
																						</li>
																						<li class="simple-menu__item">
																							<router-link to="/loyalty-advantage-program" target="_blank" class="simple-menu__link">
																								Loyalty Advantage
																								Program</router-link>
																						</li>
																						<li class="simple-menu__item">
																							<router-link to="/premier-club" target="_self" class="simple-menu__link">
																								Launch to Premier
																								Club</router-link>
																						</li>
																					</ul>
																				</div>
																				<div class="simple-menu__column">
																					<h3 class="menu-dropdown__subtitle">
																						Events and Promotions</h3>
																					<ul class="simple-menu__list simple-menu__list--wpd">
																						<li class="simple-menu__item">
																							<a href="#" target="_self" class="simple-menu__link">
																							</a>
																						</li>
																						<li class="simple-menu__item">
																							<a href="#" target="_blank" class="simple-menu__link">
																								Monthly Promotions</a>
																						</li>
																						<li class="simple-menu__item">
																							<router-link to="/all-events" target="_self" class="simple-menu__link">
																								All Events</router-link>
																						</li>
																					</ul>
																				</div>
																				<!-- End DiscoverDropdownSection2 -->
																			</div>
																		</div>
																		<div class="menu-dropdown__column menu-dropdown__column--bl">
																			<!-- DiscoverDropdownSection3 -->
																			<h3 class="menu-dropdown__title">Modiway
																				Events</h3>
																			<router-link to="/all-events" class="menu-dropdown__cta gaCrossDomain">
																				<img loading="lazy" src="~@/assets/medias/400x400-headerhomepage.jpeg" alt="">
																			</router-link>
																			<!-- End DiscoverDropdownSection3 -->
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</li>

										</ul>
									</nav>
									<div id="header_search" class="header__search" :class="{ 'open': toggleMobileSearch }">
										<div id="site-search" class="header__search-form">
											<div id="header_search_group" class="form-group">
												<label for="search" class="u--visuallyhidden">Search Products,
													Collections, Keywords...</label>
												<input type="text" class="form-control" id="header_search_input" required name="text" placeholder="Search Products, Collections, Keywords..." v-model="searchText" autocomplete="off" @keyup="onKeyUp"  @keyup.enter="onKeyEnter"/>
												<input id="contentType" name="contentType" type="hidden" value="PRODUCT" />
												<button id="header_search_button" type="button" class="btn btn--icon btn--cross" v-if="searchText" @click="searchText='';closePopup()"></button>
												<button id="header_search_button" type="button" class="btn btn--icon btn--search" v-else @click="togglePopup">Search</button>
											</div>
										</div>
									</div>
								</div>
								<nav class="header__toolbar">
									<ul class="nav">
										<li class="nav__item d-none d-md-flex d-lg-none">
											<a class="nav__link nav__link--icon" href="#" @click="toggleMobileSearch = !toggleMobileSearch">
												<span class="icon--search icon--size"></span>
												<span class="d-none d-md-block">Search</span>
											</a>
											<!-- nav-dropdown help -->
											<div class="nav-dropdown nav-dropdown--help nav-dropdown--help-in">
												<div class="nav-dropdown__head">
													<div class="nav-dropdown__title">
														How can we help?</div>
												</div>
												<div class="nav-dropdown__body">
													<ul class="nav-dropdown__list">
														<li class="nav-dropdown__item">
															<a href="../home/en_IN/policy-manual-product-return-policy.html" class="nav-dropdown__item-link" target="_self">Returns</a>
														</li>
														<li class="nav-dropdown__item">
															<a href="../home/en_IN/flyers-loyalty-rewards-program.html" class="nav-dropdown__item-link" target="_self">Loyalty
																Rewards Program</a>
														</li>
														<li class="nav-dropdown__item">
															<a href="../home/en_IN/contact-us.html" class="nav-dropdown__item-link" target="_self">Contact
																Us</a>
														</li>
														<li class="nav-dropdown__item nav-dropdown__item--nic">
															<a href="http://help.Modiway.com" class="nav-dropdown__item-link gaCrossDomain" target="_self">View all help</a>
														</li>
													</ul>
												</div>
											</div>
											<!-- /.nav-dropdown help -->
										</li>
										<li class="nav__item d-md-none d-block">
											<a class="nav__link nav__link--icon" id="searchitem-link" data-js-search-toggle @click="toggleMobileSearch = !toggleMobileSearch"><span class="icon--search "></span><span class="u--visuallyhidden"></span></a>
										</li>
										<li id="nav-account" class="nav__item nav__item--account">
											<a class="nav__link nav__link--icon js-user-dropdown" @click="toggleModal" data-nav-position="right">
												<!-- @click="toggleRightDrawer" data-nav-position="right"> -->
												<span class="icon--my-account icon--hover-brand icon-user--default icon--size"></span>
												<span class="d-none d-md-block">Account</span>
											</a>
											<!-- nav-dropdown NOT logged in start-->
											<div class="nav-dropdown nav-dropdown--account nav-dropdown--account-out" v-if="!isLoggedIn">
												<div class="nav-dropdown__body nav-dropdown__body--wpd">
													<div class="nav-dropdown__welcome">
														Welcome to Modiway</div>
													<div class="nav-dropdown__link" v-if="!isLoggedIn">
														<RouterLink to="/register" class="btn btn- " id="accountCreateAccountBtn">Create
															Account</RouterLink>
													</div>
													<div class="nav-dropdown__link" v-if="!isLoggedIn">
														<a @click="toggleModal" class="btn btn-invert" id="accountLoginBtn">Login</a>
													</div>
													<!-- <div class="nav-dropdown__link" v-if="!!isLoggedIn">
														<RouterLink class="btn btn-invert" to="/app/profile">Profile</RouterLink>
													</div>
													<div class="nav-dropdown__link" v-if="!!isLoggedIn">
														<a class="btn btn-invert" id="accountLogoutBtn" @click="logout">Logout</a>
													</div> -->
												</div>
												<!-- <div class="nav-dropdown__footer">
												</div> -->
											</div>
											<!--nav-dropdown NOT logged in end-->
										</li>
										<li id="nav-bag" class="nav__item " v-if="(!isLoggedIn && isCheckoutOrCart) || (isLoggedIn && !isCheckoutOrCart)">
											<!-- <a class="nav__link nav__link--icon" data-js-search-toggle> -->
											<a class="nav__link nav__link--icon" @click="toggleCart" data-js-search-toggle>
												<span class="">
													<img loading="lazy" src="~@/assets/common/images/icons/bag.svg" class=" icon--size" />
													<span :data-badge="totalItems" v-if="totalItems != 0" class="cart-badge">{{ totalItems
														}}</span>
												</span>
												<span class="d-none d-md-block">Cart</span>
												<!-- <span class="u--visuallyhidden"></span> -->
											</a>
										</li>
										<!-- <span>
												</span> -->
										<!-- </a> -->
										<!-- <div class="nav-dropdown nav-dropdown--help nav-dropdown--help-in">
												<div class="nav-dropdown__head">
													<div class="nav-dropdown__title">
														No Item in the cart!</div>
												</div>
											</div> -->
									</ul>
								</nav>
							</div>
						</div>
					</div>
				</div>
			</header>
		</span>
	</span>
	<CombinedModal :show="showLoginModal" @close="toggleModal" />
	<RightPanel />
	<div v-if="showPopup && isDropdownVisible" class="fullscreen-modal">
		<div class="search-modal-content">
			<div class="search-modal-header">
				<h5 class="modal-title">Search Results</h5>
				<button type="button" class="close" @click="togglePopup" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="search-modal-body">
				<!-- <div v-if="searchResults.products.length != 0" >
					<div v-for="product in searchResults.products" :key="product.id" class="modal-product-card">
						<router-link :to="`/product/${product.url_key}`" class="product-link">
						<img loading="lazy" :src="product.images[0]" alt="Product Image" class="modal-product-image" />
					</router-link>
						<div class="modal-product-details">
							<h4><RouterLink :to="'/product/' + product.url_key">{{ product.detail_name }}</RouterLink></h4>
							<p><RouterLink :to="'/product/' + product.url_key">{{ product.brand_label?product.brand_label+'-':'' }} ₹ {{ parseFloat(product.price).toFixed(2) }}</RouterLink></p>
							<button class="btn btn-primary" :class="{'added':isInCart(product.sku)}" style="margin:1px;" @click="addToCart(product)">{{ (isInCart(product.sku) ||isInCart(product.detail?.product_id)) ? 'Added to Cart' : 'Add to Cart' }}</button>
						</div>
					</div>
				</div>
				<div v-else class="no-products-message">
					<p>No products found with <i>'{{searchText}}'</i>. Please try a different search term.</p>
				</div> -->
				<div class="search-modal-body">
					<div v-if="searchResults.products.length === 0" class="no-products-message">
						<p>No products found with <i>'{{searchText}}'</i>. Please try a different search term.</p>
					</div>
					<!-- Product List -->
					<div v-for="product in searchResults.products" :key="product.id" class="modal-product-card">
						<div class="product-link">
						<router-link :to="`/product/${product.url_key}`"><img loading="lazy" :src="product.images[0]" alt="Product Image" class="modal-product-image" /></router-link>
						<div class="modal-product-details">
							<h4><RouterLink :to="'/product/' + product.url_key">{{ product.detail_name }}</RouterLink></h4>
							<p><RouterLink :to="`/product/${product.url_key}`">{{ product.brand_label?product.brand_label+'-':'' }} ₹ {{ parseFloat(product.price).toFixed(2) }}</RouterLink></p>
							<button class="btn btn-primary" :class="{'added':isInCart(product.sku)}" v-show="isLoggedIn" style="margin:1px;" @click="addToCart(product)">{{ isInCart(product.sku) ? 'Added to Cart' : 'Add to Cart' }}</button>
						</div>
					</div>
					</div>
				</div>
			</div>
				<div class="search-modal-footer">
				<button type="button" class="btn btn-secondary" @click="closePopup">Close</button>
				<RouterLink :to="'/products/search/' + searchText + '?hideFilters=true'" class="show-all-button" @click="showPopup=false" v-if="searchResults.products.length>0"><button type="button" class="btn btn-primary">Show all search results</button></RouterLink>
			</div>
		</div>
	</div>
</template>

<script>
import { ref, computed, onMounted, inject, reactive } from 'vue';
import { useCategories } from '@/composables/useCategories';
import CombinedModal from '@/components/common/CombinedModal.vue';
import { useCartStore } from '@/stores/cart';
import { useUserStore } from '@/stores/userStore';
// import { showToast } from '@/utils/toaster';
import desktopLogo from '@/assets/common/images/wqa/logo_mobile-2.png';
import mobileLogo from '@/assets/common/images/wqa/logo_mobile-2.png';
import RightPanel from '../common/RightPanel.vue';
import eventBus from '@/utils/eventBus';
import { useProducts } from '@/composables/useProducts';
import { useRoute } from 'vue-router';
export default {
	name: "app-header",
	components: {
		CombinedModal, RightPanel
	},
	watch: {
		$route(to, from) {
			if (to.fullPath !== from.fullPath) {
				this.isDropdownVisible = false;
				this.showPopup = false;
				this.isLeftBurgerMenuOpen = false;
				this.searchTextt = '';
			}else{
				this.isDropdownVisible = false;
				this.showPopup = false;
				this.isLeftBurgerMenuOpen = false;
				this.searchTextt = '';
			}
		}
		},
	methods:{
		toggleDropdown() {
			// alert('clocked')
			this.isDropdownVisible = true;
			// this.isDropdownVisible = !this.isDropdownVisible;
		},
	},
	setup() {
		const cartStore = useCartStore();
		const userStore = useUserStore();
		const axios = inject('axios');
		const route = useRoute();
		// const isCheckoutOrCart = true;
		const isCheckoutOrCart = computed(() => (route.fullPath.includes('checkout') || route.fullPath.includes('cart')));
		const { categories, loading, error, fetchCategories } = useCategories(axios);
		const { searchProducts } = useProducts(axios);
		// cartStore.clearCart();
		// alert('cleared from header')
		const toggleMobileSearch = ref(false);
		const searchText = ref('');
		const showLoginModal = ref(false);
		const isMobileDiscoverVisible = ref(false);
		const isMobileStoriesVisible = ref(false);
		const isMobileCategoriesVisible = ref(false);
		const activeCategory = ref(null);
		const hoveredCategory = ref(null);
		const isLeftBurgerMenuOpen = ref(false);
		const isRightMenuOpen = ref(false);
		const showPopup = ref(false); // Control popup visibility
		const searchResults = ref({
			products: []
		});
		const isCartOpen = ref(false);
		const windowWidth = ref(window.innerWidth);

		const isLoggedIn = computed(() => userStore.isLoggedIn);
		const totalItems = computed(() => cartStore.totalItems);

		const addToCart = (product) => {
			cartStore.addToCart(product);
			// showToast('addToCart');
		};

		const logout = () => {
			userStore.destroySession();
			cartStore.destroyCart();
			window.location.href = '/';
			// showToast('loggedOut');
		};

		const toggleModal = () => {
			if (!isLoggedIn.value) {
				showLoginModal.value = !showLoginModal.value;
			} else {
				// window.location.href = '/app/profile'
				if(eventBus.panelOpen){
					eventBus.panelOpen("Profile")
				}
			}
		};
		const isDropdownVisible = ref(true);
		const toggleSubcategory = (categoryId) => {
			activeCategory.value = activeCategory.value === categoryId ? null : categoryId;
		};

		const showSubcategories = (categoryId) => {
			hoveredCategory.value = categoryId;
		};

		const hideSubcategories = () => {
			hoveredCategory.value = null;
		};

		const toggleLeftDrawer = () => {
			isLeftBurgerMenuOpen.value = !isLeftBurgerMenuOpen.value;
			isDropdownVisible.value = true;
		};

		const toggleRightDrawer = () => {
			isRightMenuOpen.value = !isRightMenuOpen.value;
		};

		const onKeyUp = (event) => {
			searchText.value = event.target.value;
			togglePopup(); 
			// Count only alphabetic characters
			const charCount = searchText.value.replace(/[^a-zA-Z]/g, '').length;

			if (charCount >= 3) {
				fetchSearchResults(searchText.value);
			} else {
				closePopup();
			}
		};
		const onKeyEnter = (event) => {
			searchText.value = event.target.value;
			togglePopup(); 
			// Count only alphabetic characters
			const charCount = searchText.value.replace(/[^a-zA-Z]/g, '').length;

			if (charCount >= 3) {
				fetchSearchResults(searchText.value);
			} else {
				closePopup();
			}
			event.target.blur();
		};

		// Reactive JSON data for logo
		const logoData = reactive({
			desktopLogo: desktopLogo,
			mobileLogo: mobileLogo,
			route: '/'
		})
		const currentLogo = ref(logoData.mobileLogo);

		const updateLogo = () => {
			if (window.innerWidth > 1024) {
				// console.log("if logo");

				currentLogo.value = logoData.desktopLogo;
			} else {
				//   console.log("if logo");
				currentLogo.value = logoData.mobileLogo;
			}
		};

		
		const fetchSearchResults =  async(query) => {
  try {
    // Show the modal and reset previous results
    showPopup.value = true;
    searchResults.value.products = []; // Clear previous results
    
   
    const response =  await searchProducts(query, 6);
    searchResults.value.products = response.data.products;
  } catch (error) {
    console.error('Error fetching search results:', error);
  } 
};

		const closePopup = () => {
			showPopup.value = false;
		};
		const togglePopup =()=>{
			isLeftBurgerMenuOpen.value = false;
			showPopup.value= !showPopup.value;
			isDropdownVisible.value= true;
		};

		const toggleCart = () => {
			if(eventBus.panelOpen){
				eventBus.panelOpen();
			}
		};

		const handleResize = () => {
			windowWidth.value = window.innerWidth;
			updateLogo();
			// Example responsive logic
			if (windowWidth.value > 1024) {
				// console.log("call mobile");
				isLeftBurgerMenuOpen.value = false;

			} else {
				// console.log("call full");

			}
		};

		onMounted(() => {
			fetchCategories();
			updateLogo();
			window.addEventListener('resize', handleResize);
		});
		const isInCart = (productId) => {
			return cartStore.isInCart(productId);
		};
		return {
			isCheckoutOrCart,
		searchText,
			isDropdownVisible,
			isInCart,
			addToCart,
			logout,
			isLoggedIn,
			toggleModal,
			toggleSubcategory,
			showSubcategories,
			hideSubcategories,
			toggleLeftDrawer,
			toggleRightDrawer,
			onKeyUp,
			onKeyEnter,
			fetchSearchResults,
			closePopup,
			toggleCart,
			isCartOpen,
			totalItems,
			categories,
			loading,
			error,
			axios,
			showLoginModal,
			isMobileDiscoverVisible,
			isMobileStoriesVisible,
			isMobileCategoriesVisible,
			activeCategory,
			isLeftBurgerMenuOpen,
			isRightMenuOpen,
			showPopup,
			searchResults,
			windowWidth,
			togglePopup,
			logoData, toggleMobileSearch, currentLogo
		};
	},
};
</script>
<style scoped>
.no-products-message{
	text-align:center;
	width: fit-content;
	margin:0 auto;
}
.wqa a {
	text-decoration: none !important;
}

@media (max-width:1024px) {
	.cart-badge {
		top: 1px !important;
	}
}

.cart-badge {
	position: absolute;
	margin-left: 1px;
	top: 10px;
	left: 25px;
	width: 23px;
	height: 23px;
	background-color: #2897ff;
	color: #fff;
	border-radius: 50%;
	content: attr(data-badge);
	font-size: 12px;
	/* font-family: Montserrat Regular, sans-serif; */
	display: inline-flex;
	align-items: center;
	justify-content: center;
}

a#accountCreateAccountBtn {
	color: white !important;
}

a#accountCreateAccountBtn:hover {
	background-color: #09608b !important;
}

.wqa-design a:hover,
.wqa-design a:focus,
.wqa-design a:active {
	color: #094372 !important;
}

span {
	font-size: 11.2px;
}

.wqa-design .nav__link {
	font-size: 16px;
}

.btn--icon.btn--search {
	background-image: url('~@/assets/common/images/icons/icon-search-primary.svg');
	width: 40px;
	height: 40px;
	background-color: none;
	/* height: 1.9375em; */
}
.btn--icon.btn--cross {
	background-image: url('~@/assets/common/images/icons/cross.svg');
	background-size: cover;
	position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
	width: 40px;
	height: 40px;
	background-color: none;
	/* height: 1.9375em; */
}
.btn--icon.btn--search {
	background-image: url('~@/assets/common/images/icons/icon-search-primary.svg');
	width: 40px;
	height: 40px;
	background-color: none;
	/* height: 1.9375em; */
}

@media only screen and (max-width: 600px) {
    .icon--search:before {
	background-image: url('~@/assets/common/images/icons/search.svg');
	width: 30px !important;
	height: 30px !important;
	}

	.icon--my-account:before {
		background-image: url('~@/assets/common/images/icons/my-account.svg');
		width: 30px !important;
		height: 30px !important;
	}

	.icon--size {
		width: 30px !important;
		height: 30px !important;
	}
}

.icon--search:before {
	background-image: url('~@/assets/common/images/icons/search.svg');
	width: 40px;
	height: 40px;
	/* height: 1.9375em; */
}

.btn.btn--icon.btn--search {
	background-color: white !important;
}
.btn.btn--icon.btn--cross {
	background-color: white !important;
}

.icon--burger:before {
	background-image: url('~@/assets/common/images/icons/burger.svg');
	width: 40px;
	height: 40px;
	/* height: 1.9375em; */
}

.icon--cross:before {
	background-image: url('~@/assets/common/images/icons/cross.svg');
	width: 40px;
	height: 40px;
	/* height: 1.9375em; */
}

.icon--help-circle:before {
	background-image: url('~@/assets/common/images/icons/help-circle.svg');
	width: 40px;
	height: 40px;
	/* height: 1.9375em; */
}

.icon--my-account:before {
	background-image: url('~@/assets/common/images/icons/my-account.svg');
	width: 40px;
	height: 40px;
	/* width: 1.9375em; */
}

.offcanvas-menu-left {
	left: 0 !important;
}

/* .offcanvas-menu-right {
	right: 0 !important;
	left: auto;
} */

.wqa-design .offcanvas-menu-left .mobile-menu--nav {
	display: block;
	/* overflow-y: scroll; */
	overflow-x: hidden;
}

.wqa-design .drill-nav__item.has-child-menu .drill-nav__link {
	background: url('~@/assets/common/images/wqa/icons/icon-chevron-right-secondary.svg') calc(100% - 14px) center no-repeat transparent;
}

.wqa-design .drill-nav__item.has-child-menu:hover {
	background: url('~@/assets/common/images/wqa/icons/icon-chevron-right-primary.svg') calc(100% - 14px) center no-repeat transparent;
	/* background-image: url('../assets/common/images/wqa/icons/icon-chevron-right-primary.svg'); */
}

.drill-nav__link.child {
	background: none !important;
}

.wqa-design .push-nav__item.has-child-menu>.push-nav__link {
	background-image: url('https://www.doterra.com/_ui/desktop/common/images/wqa/icons/icon-chevron-right-secondary.svg');
}

.wqa-design .push-nav__item.has-child-menu>.push-nav__link {
	font-weight: 700;
	background: url('https://www.doterra.com/_ui/desktop/common/images/wqa/icons/icon-chevron-right-secondary.svg') calc(100% - 35px) center no-repeat transparent;
	background-size: 9px;
	transition: none;
}

a {
	color: #354657 !important;
}

.icon--size {
	width: 40px;
	height: 40px;
}

.fullscreen-modal {
	position: fixed;
	top: auto;
	left: 0;
	width: 100%;
	height: 100%;
	background: white;
	z-index: 99;
	/* Ensure it's above other content */
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
}

.search-modal-content {
	width: 80%;
	height: calc(100% - 60px);
	/* Adjust the height to exclude the header height */
	background: white;
	overflow-y: auto;
	margin-top: 16px;
	/* Adjust to match the height of your header */
	border-radius: 0;
	/* Remove border-radius for a full-width modal */
}

.search-modal-body {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	/* To evenly space the cards */
	padding: 0px 10%;
	/* padding: 20px 10%; */
}

.modal-product-card {
	display: flex;
	align-items: center;
	border-radius: 5px;
	margin-bottom: 15px;
	padding: 10px;
	transition: box-shadow 0.3s ease;
	width: 48%;
	/* Adjust width to fit two cards in a row */
	box-sizing: border-box;
	/* Ensures padding/margin don't affect total width */
	Height: auto;
	max-height:69vh;
	box-shadow: none;
}

@media (max-width:768px) {
	.wqa-design #offcanvas-menu {
		top: 65px !important;
	}


}

.modal-product-card:hover {
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.modal-product-image {
	width: 50px;
	height: 50px;
	object-fit: cover;
	margin-right: 15px;
}

.modal-product-details {
	text-align: left;
}

.modal-product-details h4 {
	margin: 0;
	color: #6d3e94;
	font-weight: 500;
	font-size:16px;
}

.modal-product-details p {
	margin: 0;
	color: #767676;
	font-size: 16px;
    font-weight: 700;
}

.product-link {
	display: flex;
	text-decoration: none;
	color: inherit;
	/* Inherit the color from the parent to avoid the default link color */
}


.search-modal-footer {

	align-items: center;
}

.search-modal-footer button {

	margin: 0px 20px;
}

@media (max-width:768px) {

	.wqa-design #offcanvas-menu {
		top: 65px !important;
	}

	.header__inner {
		height: 60px !important;
	}

}

@media screen and (min-width: 380px) {
	#searchitem-link {
		padding: 7px 0px 0px 0px;
	}
}

@media (max-width: 480px) {
	.wqa-design .header__search.open {
		top: 65px !important;
	}

	.search-modal-content {
		width: 100%;
	}

	.modal-product-card {
		width: 100%;
	}
}
.added{
  background-color: #05354d !important;
  border-color: #05354d !important;
}

</style>